/**
 * Состав пака «soft-rounded» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 32 воронок: паки/*.json, поле nearest (ближайший из 12 прежних паков)
  palettes: [
    // 7 из 32 воронок: palette → ближайшая тема по цветам
    { themeId: 'ink-premium', weight: 0.22 },
    // 6 из 32 воронок: palette → ближайшая тема по цветам
    { themeId: 'slate-pro', weight: 0.19 },
    // 3 из 32 воронок: palette → ближайшая тема по цветам
    { themeId: 'royal-purple', weight: 0.09 },
  ],
  fonts: [
    // 19 из 32 воронок: fontId
    { fontId: 'inter', weight: 0.59 },
    // 5 из 32 воронок: fontId
    { fontId: 'opensans', weight: 0.16 },
    // 4 из 32 воронок: fontId
    { fontId: 'poppins', weight: 0.12 },
  ],
  screenKinds: [
    // средняя доля экранов по 32 воронкам (признаки.json kinds) 0.366; сюда свёрнуты Q10, Q13, Q6, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.43 },
    // средняя доля экранов по 32 воронкам (признаки.json kinds) 0.104; сюда свёрнуты I2 (замена из arsenal.mjs)
    { kind: 'I1', share: 0.12 },
    // средняя доля экранов по 32 воронкам (признаки.json kinds) 0.081; сюда свёрнуты Q3 (замена из arsenal.mjs)
    { kind: 'Q2', share: 0.1 },
    // средняя доля экранов по 32 воронкам (признаки.json kinds) 0.078; сюда свёрнуты Q16 (замена из arsenal.mjs)
    { kind: 'N4', share: 0.09 },
    // средняя доля экранов по 32 воронкам (признаки.json kinds) 0.070
    { kind: 'Q8', share: 0.08 },
    // средняя доля экранов по 32 воронкам (признаки.json kinds) 0.069
    { kind: 'N1', share: 0.08 },
    // средняя доля экранов по 32 воронкам (признаки.json kinds) 0.041
    { kind: 'N5', share: 0.05 },
    // средняя доля экранов по 32 воронкам (признаки.json kinds) 0.040; сюда свёрнуты Q7 (замена из arsenal.mjs)
    { kind: 'Q5', share: 0.05 },
  ],
  blocks: [
    // в 26 из 32 воронок (признаки.json blocks), подъём 1.80; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): optionIndicator 71 из 128
    {
      type: 'multiple_choice',
      weight: 0.81,
      settings: { optionIndicator: 'none' },
    },
    // в 31 из 32 воронок (признаки.json blocks), подъём 1.41; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 347 из 414, optionIndicator 316 из 414
    {
      type: 'single_choice',
      weight: 0.97,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 21 из 32 воронок (признаки.json blocks), подъём 1.63
    { type: 'email', weight: 0.66, settings: {} },
    // в 16 из 32 воронок (признаки.json blocks), подъём 1.73
    { type: 'text_field', weight: 0.5, settings: {} },
    // в 18 из 32 воронок (признаки.json blocks), подъём 1.17
    { type: 'loader_processing', weight: 0.56, settings: {} },
    // в 5 из 32 воронок (признаки.json blocks), подъём 2.99
    { type: 'preference_card', weight: 0.16, settings: {} },
    // в 8 из 32 воронок (признаки.json blocks), подъём 1.75; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): testimonialQuoteMarks 22 из 32
    {
      type: 'testimonials',
      weight: 0.25,
      settings: { testimonialQuoteMarks: true },
    },
  ],
  niches: [
    // 4 из 32 воронок (признаки.json theme)
    { niche: 'weight_loss', weight: 0.12 },
    // 4 из 32 воронок (признаки.json theme)
    { niche: 'language_learning', weight: 0.12 },
    // 4 из 32 воронок (признаки.json theme)
    { niche: 'mental_health', weight: 0.12 },
    // 3 из 32 воронок (признаки.json theme)
    { niche: 'hobbies', weight: 0.09 },
  ],
};
